import "./SupremeLawOffice.module.css";
import Header from "@/reusable_sections/Header";
import Aboutfirm from "./sections/Aboutfirm";
import Footer from "@/reusable_sections/Footer";
export default function SupremeLawOfficePage() {
  return <div>
      <Header />
      <Aboutfirm />
      <Footer />
    </div>;
}